import React from 'react';
import {
  InformationSectionContainer,
  InformationSectionDescription,
  InformationSectionDevicesSvgContainer,
  InformationSectionImageContainer,
  InformationSectionSubscriptionButtonContainer,
  InformationSectionSubscriptionButtonShell,
  InformationSectionTextContainer,
  InformationSectionTitle
} from './IntroductionSectionStyle';
import { withContent } from '../../hoc/withContext';
import { IContext } from '../../types';
import PictureImage from '../utils/Picture';
import {getSvgComponent} from "../utils/svg";
import CONFIG from "../../config";
import {MULTI_ACCESS_KEY} from "../../constants";
import SubscriptionButton from "../utils/SubscriptionButton";

const IntroductionSectionContainer = ({ context }: IContext) => {
  return (
    <InformationSectionContainer>
      <InformationSectionTextContainer>
        <InformationSectionDevicesSvgContainer>
          {getSvgComponent('introductionDevices')}
        </InformationSectionDevicesSvgContainer>
        <InformationSectionTitle dangerouslySetInnerHTML={{ __html: context.introductionSection.title }} />
        <InformationSectionDescription dangerouslySetInnerHTML={{ __html: context.introductionSection.description }} />
        <InformationSectionSubscriptionButtonShell>
          <discover-components-subscription-price
              locale={context.lang.split('_')[0]}
              theme={CONFIG.isUPC ? 'uplay' : 'store'}
              customTheme={CONFIG.isUPC ? 'uplay' : 'store'}
              size="defaultSizes"
              textColor={'white'}
              ubisoftPlusAccountType={MULTI_ACCESS_KEY}
          ></discover-components-subscription-price>
        </InformationSectionSubscriptionButtonShell>
        <InformationSectionSubscriptionButtonContainer>
          <SubscriptionButton idToAttach={'introductionSectionSubscriptionButton'} />
        </InformationSectionSubscriptionButtonContainer>
      </InformationSectionTextContainer>
      <InformationSectionImageContainer>
        <PictureImage
          images={[{
            imageName: 'cloudDevices_desktop',
            minWidth: 1720
          }, {
            imageName: 'cloudDevices_smallDesktop',
            minWidth: 1300
          }
          , {
            imageName: 'cloudDevices_tablet',
            minWidth: 1000
          },{
            imageName: 'cloudDevices_smallTablet',
            minWidth: 721
          }, {
            imageName: 'cloudDevices_mobile',
            minWidth: 0
          }
          ]}
          extension="png"
          altText={''}
          containsWebp={false}
          className={['']}
        />
      </InformationSectionImageContainer>
    </InformationSectionContainer>
  );
};

export default withContent(IntroductionSectionContainer);